module.exports = __webpack_public_path__ + "static/media/network.51b78972.png";